import $ from "jquery";
import AOS from "aos";

// $(function () {
$(document).ready(function () {
  $(".amdg-aos-fade-up").attr({
    "data-aos": "fade-up",
  });

  // $('[class*="amdg-aos-duration"]').each(function () {
  //   const classes = $(this).attr("class").split(" ");
  //   let durationValue = "";
  //   $.each(classes, function (index, value) {
  //     if (value.search(/amdg-aos-duration/i) == 0) {
  //       durationValue = value.split(":").pop();
  //     }
  //   });
  //   $(this).attr({
  //     "data-aos-duration": durationValue,
  //   });
  // });

  // $('[class*="amdg-aos-delay"]').each(function () {
  //   const classes = $(this).attr("class").split(" ");
  //   let delayValue = "";
  //   $.each(classes, function (index, value) {
  //     if (value.search(/amdg-aos-delay/i) == 0) {
  //       delayValue = value.split(":").pop();
  //     }
  //   });
  //   $(this).attr({
  //     "data-aos-delay": delayValue,
  //   });
  // });

  // $('[class*="amdg-aos-easing"]').each(function () {
  //   const classes = $(this).attr("class").split(" ");
  //   let easingValue = "";
  //   $.each(classes, function (index, value) {
  //     if (value.search(/amdg-aos-easing/i) == 0) {
  //       easingValue = value.split(":").pop();
  //     }
  //   });
  //   $(this).attr({
  //     "data-aos-easing": easingValue,
  //   });
  // });

  // $('[class*="amdg-aos-offset"]').each(function () {
  //   const classes = $(this).attr("class").split(" ");
  //   let offsetValue = "";
  //   $.each(classes, function (index, value) {
  //     if (value.search(/amdg-aos-offset/i) == 0) {
  //       offsetValue = value.split(":").pop();
  //     }
  //   });
  //   $(this).attr({
  //     "data-aos-offset": offsetValue,
  //   });
  // });

  // $('[class*="amdg-aos-anchor"]').each(function () {
  //   const classes = $(this).attr("class").split(" ");
  //   let anchorValue = "";
  //   $.each(classes, function (index, value) {
  //     if (value.search(/amdg-aos-anchor/i) == 0) {
  //       anchorValue = value.split(":").pop();
  //     }
  //   });
  //   $(this).attr({
  //     "data-aos-anchor": anchorValue,
  //   });
  // });

  // let scrollRef = 0;

  // window.addEventListener('scroll', function() {
  //   // increase value up to 10, then refresh AOS
  //   scrollRef <= 10 ? scrollRef++ : AOS.refresh();
  // });

  // attr({
  //   "data-aos": "fade-up",
  // });
});

$(window).on("load", function () {
  AOS.init({
    once: true,
    disable: function () {
      var maxWidth = 768;
      return window.innerWidth < maxWidth;
    },
    easing: "cubic",
    duration: "1000",
  });
});
